const loadSwiper = () => {
    return new Promise((resolve, reject) => {
        if (typeof Swiper !== 'undefined') {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = '/wp-content/themes/asbestos/assets/js/plugins/swiper.js';

        const styleLink = document.createElement('link');
        styleLink.rel = 'stylesheet';
        styleLink.href = '/wp-content/themes/asbestos/assets/third-party/styles/swiper.css';

        script.onload = () => {
            resolve();
        };

        script.onerror = (error) => {
            reject(error);
        };

        document.head.appendChild(script);
        document.head.appendChild(styleLink);
    });
};

const runSwiper = () => {
    if (!document.querySelector(".swiper")) {
        return;
    }

    loadSwiper()
        .then(() => {
            if (typeof Swiper === 'undefined') {
                return;
            }

            const defaultElement = document.querySelector(".swiper-default");
            if (defaultElement) {
                const defaultSwiper = new Swiper(".swiper.swiper-default", {
                    direction: 'horizontal',
                    loop: true,
                    breakpoints: {
                        400: { slidesPerView: 1 },
                        700: { slidesPerView: 2 },
                        1000: { slidesPerView: 3 }
                    },
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }

            const bookElement = document.querySelector(".swiper-book");
            if (bookElement) {
                const bookSwiper = new Swiper(".swiper-book", {
                    direction: 'horizontal',
                    breakpoints: {
                        400: { slidesPerView: 1 },
                        1000: { slidesPerView: 2 }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: (index, className) => `<span class="${className}">${index + 1}</span>`,
                    },
                });
            }

            const testimonialElement = document.querySelector(".swiper-testimonial");
            if (testimonialElement) {
                const testimonialSwiper = new Swiper(".swiper-testimonial", {
                    direction: 'horizontal',
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            }

            const testimonial3ColElement = document.querySelector(".swiper-testimonial-3-col");
            if (testimonial3ColElement) {
                const testimonial3Col = new Swiper(".swiper-testimonial-3-col", {
                    direction: 'horizontal',
                    breakpoints: {
                        400: { slidesPerView: 1 },
                        700: { slidesPerView: 2 },
                        1000: { slidesPerView: 3 }
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            }
        });
}

runSwiper();
